export enum B2CPolicyType {
	SignUpSignIn = 'signUpSignIn',
	ResetPassword = 'resetPassword',
	EditProfile = 'editProfile',
}
